import { gql } from "@apollo/client";

export const CREATE_PRINTER = gql`
  mutation createPrinter($input: PrinterCreateInput!) {
    createPrinter(input: $input) {
      _id
      name
      brand
      length
      height
      width
      ownerId
      supportedFiles
      featuredImage
      countryCode
      postalAddress
      postServiceCode
      active
      comments
      filaments{
        name
        price
      }
      images
      weight
      createdAt
      updatedAt
    }
  }
`;
